module.exports = __webpack_public_path__ + "img/solucoesTecnologiaOPENCARD2.64f476a8.jpg";